import classNames from "classnames";
import type { FC, SVGProps } from "react";
import React from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const LoadingAnimationIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Loading spinner"
      className={classNames("spinner", props.className)}
      {...props}
    >
      <title id="titleId">loading icon</title>

      <g className="spinner">
        <rect
          x="11"
          y="1"
          width="2"
          height="5"
          opacity="0.14"
          fill={props.fill || "currentColor"}
          className="rounded-fds-2"
        />
        <rect
          x="11"
          y="1"
          width="2"
          height="5"
          transform="rotate(30 12 12)"
          opacity="0.29"
          fill={props.fill || "currentColor"}
          className="rounded-fds-2"
        />
        <rect
          x="11"
          y="1"
          width="2"
          height="5"
          transform="rotate(60 12 12)"
          opacity="0.43"
          fill={props.fill || "currentColor"}
          className="rounded-fds-2"
        />
        <rect
          x="11"
          y="1"
          width="2"
          height="5"
          transform="rotate(90 12 12)"
          opacity="0.57"
          fill={props.fill || "currentColor"}
          className="rounded-fds-2"
        />
        {/* <rect
          x="11"
          y="1"
          width="2"
          height="5"
          transform="rotate(120 12 12)"
          opacity="0.71"
          fill={props.fill || "currentColor"}
        /> */}
        <rect
          x="11"
          y="1"
          width="2"
          height="5"
          transform="rotate(150 12 12)"
          opacity="0.86"
          fill={props.fill || "currentColor"}
          className="rounded-fds-2"
        />
        {/* <rect
          x="11"
          y="1"
          width="2"
          height="5"
          transform="rotate(180 12 12)"
          fill={props.fill || "currentColor"}
        /> */}
      </g>
    </svg>
  );
};

export default LoadingAnimationIcon;
